// 定义基于 backend/app/models/validation.py 的类型

// 告警严重程度
export enum AlertSeverity {
    INFO = 'INFO',       // 信息
    WARN = 'WARN',       // 警告
    ERROR = 'ERROR',     // 错误
    CRITICAL = 'CRITICAL', // 严重
}

// 告警类型
export enum AlertType {
    VOLATILITY = 'VOLATILITY',   // 价格波动异常
    DATA_QUALITY = 'DATA_QUALITY', // 数据质量问题
    SOURCE_ERROR = 'SOURCE_ERROR', // 数据源故障
    CROSS_CHECK = 'CROSS_CHECK',   // 交叉验证失败
}

// 验证告警接口定义
export interface ValidationAlert {
    id: number;
    source: string;          // 来源
    data_type: string;       // 数据类型
    alert_type: AlertType;   // 告警类型
    severity: AlertSeverity; // 严重程度
    message: string;         // 告警消息
    details?: Record<string, any>; // 详细信息
    is_resolved: boolean;    // 是否已解决
    created_at: string;      // 创建时间
    resolved_at?: string;    // 解决时间
}

const API_BASE = '/api/v1/validation/';

export const validationService = {
    // 获取所有告警 (可选筛选是否已解决)
    getAlerts: async (resolved?: boolean): Promise<ValidationAlert[]> => {
        const url = new URL(API_BASE, window.location.origin);
        if (resolved !== undefined) {
            url.searchParams.append('resolved', String(resolved));
        }

        const response = await fetch(url.toString(), {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('admin_token')}`
            }
        });

        if (!response.ok) {
            if (response.status === 401) {
                throw new Error('Unauthorized');
            }
            throw new Error(`Failed to fetch alerts: ${response.statusText}`);
        }
        return response.json();
    },

    // 解决特定告警
    resolveAlert: async (id: number): Promise<void> => {
        const response = await fetch(`${API_BASE}/${id}/resolve`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('admin_token')}`
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to resolve alert: ${response.statusText}`);
        }
    },
};
